import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import {makeStyles} from '@material-ui/core/styles';
import { Table } from 'antd';
import localforage from 'localforage';
import {useGroupDeviceState} from './Provider';
import StoreApi from '@/apis/storeAPI';
const useModalStyles = makeStyles(theme => ({
  StoreAccountModal: {
    marginRight: theme.spacing(0.75),
    '& .StoreAccountBox': {
      height: '100%',
      '& .ant-pagination': {
        margin: "20px 0 0 0 !important"
      },
      '& span.status': {
        //border: 1px solid #ddd;
        padding: '2px 10px',
        minWidth: '62px',
        display: 'inline-block',
        textAlign: 'center',
        borderRadius: '20px',
        fontSize: '0.8rem',
        lineHeight: '20px'
      },
      '& span.status.status-0': {
        color: '#F7862A',
        backgroundColor: '#fef1e7'
      },
      '& span.status.status-1': {
        color: '#5258DD',
        backgroundColor: '#eaebfa',
        //border: 1px solid #00afc6;
      }
    }
  }
}));

function TranserModal({ open, value, onSelect, onConfirm, onClose,storeId }) {
  const { t } = useTranslation();
  // table loading
  const [tableLoading, setTableLoading] = useState(true)
  // table data
  const [tableData, setTableData] = useState([])
  const [state,setState] = useState({
    accountNum: 0,
    page:1,
    page_size: 20,
    total: 0
  })
  const StoreAccountTableRef = useRef(null)

  const classes = useModalStyles()

  const { currentCompanyId } = useGroupDeviceState()

  const handleConfirm = () => {
    // if (!selected.length) {
    //   toast.info(t({ defaultMessage: "请选择一个标签" }));
    //   return;
    // }
  };

  useEffect(() => {
    if(open){
      reloadTableData()
    }
  }, [open]);

  const reloadTableData = async () => {
    const user_company_id = await localforage.getItem("userCompanyID")
    const res = await StoreApi.GetStoreAccount({
      company_id:currentCompanyId ? currentCompanyId : user_company_id,
      group_id: storeId,
      page: state.page,
      page_size: state.page_size
    })
    const data = res.data.list
    setState({
      ...state,
      total:res.data.total
      // page: res.data.page
    })
    setTableData(data)
    setTimeout(()=>{
      setTableLoading(false)
    },2000)
  }

  const TableList = () => {
    const tableFunc = {
      // 排序，分页等等
      onChange: (pagination, filters, sorter, extra) => {
        // console.log('params', pagination, filters, sorter, extra);
        state.page = pagination.current
        state.page_size = pagination.pageSize
        // console.log(pageSetting)
        reloadTableData()
      },
    }
    const columns = [
      {
        title: t({defaultMessage: "姓名"}),
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        fixed: 'left',
        width: 120,
        render: (_,record) => {
          return record.name
        },
      },{
        title: t({defaultMessage: "手机"}),
        dataIndex: 'phone',
        key: 'phone',
        align: 'center',
        fixed: 'left',
        width: 120,
        render: (_,record) => {
          return record.phone
        },
      },{
        title: t({defaultMessage: "邮箱"}),
        dataIndex: 'email',
        key: 'email',
        align: 'center',
        width: 200,
        render: (_,record) => {
          return record.email
        },
      },{
        title: t({defaultMessage: "角色"}),
        dataIndex: 'roles',
        key: 'roles',
        align: 'center',
        width: 120,
        render: (_,record) => {
          const roleNameArr = []
          if(record.roles) {
            record.roles.forEach(item=>{
              roleNameArr.push(item.name)
            })
          }
          return roleNameArr.join(',')
        },
      },{
        title: t({defaultMessage: "状态"}),
        dataIndex: 'active_status',
        key: 'active_status',
        align: 'center',
        width: 100,
        render: (_,record) => {
          const activeStatus = record.active_status ? 1 : 0
          const statusOption = {
            0: t({defaultMessage: "未激活"}),
            1: t({defaultMessage: "已触发"}),
          }
          return <span className={`status status-${activeStatus}`}>{`${statusOption[activeStatus]}`}</span>
        },
      },{
        title: "2FA",
        dataIndex: 'otp_required',
        key: 'otp_required',
        align: 'center',
        width: 100,
        render: (_,record) => {
          const statusOption = {
            0: t({defaultMessage: "未开启"}),
            1: t({defaultMessage: "已开启"})
          }
          return <span className={`status status-${record.otp_required}`}>{`${statusOption[record.otp_required]}`}</span>
        },
      }
    ]

    return <>
      <Table ref={StoreAccountTableRef}
             rowKey="id"
             columns={columns}
             dataSource={tableData}
             loading={tableLoading}
             scroll={{x: 'calc(700px + 20%)',y: '300px' }}
             onChange={tableFunc.onChange}
             pagination={{
               pageSize: state.page_size,
               showSizeChanger: true,
               showQuickJumper:true,
               pageSizeOptions: [5,10,20,50,100],
               current: state.page,
               showTotal : (total) => `${t({defaultMessage: "共{total}条"},{total: total}) }`,
               total:state.total
             }}
      />
    </>
  }

  return (
    <Modal
      title={t({ defaultMessage: "账号" })+`（`+state.total+`）`}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      width={800}
      height={420}
      className={classes.StoreAccountModal}
      footer=""
    >
      <div className={`StoreAccountBox paltform-antd-table`}>
        <TableList />
      </div>
    </Modal>
  );
}

export default TranserModal;
